module.exports = __webpack_public_path__ + "img/d_01.6e1c243b.png";